// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2kBbz","col":"styles_col__3_n5D"};